export const getSubstringId = (itemId: string) =>
  itemId.split('--');
